import type { Config } from "tailwindcss";
import sharedConfig from "../core/tailwind.config.js";

export default {
	content: ["../core/**/*.{html,css,svelte,ts}", "./src/**/*.{html,css,svelte,ts}", "./*.{html,css,svelte,ts}"],
	plugins: [],
	presets: [sharedConfig],
} satisfies Config;
